import balanceEnabled from '@/actions-permission/balance.permissions'

const FINANCIAL = ({
  routeName,
  permissionIsEnabled,
  componentIsEnabled,
  businessModel
}) => {
  const showBalanceSection = balanceEnabled(
    permissionIsEnabled,
    componentIsEnabled,
    businessModel
  )
  return {
    key: 'financial',
    label: 'sidemenu.financial',
    showSection: showBalanceSection,
    items: {
      balance: {
        label: 'sidemenu.submenu.financial.balance',
        showItem: showBalanceSection,
        beta: false,
        active: ['balance', 'anticipationRequest'].includes(routeName)
      },
      transfers: {
        label: 'sidemenu.submenu.financial.transfers',
        showItem: showBalanceSection,
        beta: false,
        active: ['transfers', 'transfersDetail', 'transfersRequest'].includes(
          routeName
        )
      },
      anticipations: {
        label: 'sidemenu.submenu.financial.anticipations',
        showItem: showBalanceSection,
        beta: false,
        active: ['anticipations', 'anticipationsDetail'].includes(routeName)
      },
      settlements: {
        label: 'sidemenu.submenu.financial.settlements',
        showItem: showBalanceSection,
        beta: false,
        active: ['settlements'].includes(routeName)
      },
      earningStatements: {
        label: 'sidemenu.submenu.financial.earning-statements',
        showItem: showBalanceSection,
        beta: false,
        active: ['earningStatements'].includes(routeName)
      }
    }
  }
}

export default FINANCIAL
